import api from './api';

export const getList = (params = {}) => api().get('/component', { params });
export const deleteComponent = (params) => {
    const ids = (params || []).map((x) => x.component_id);
    return api().post(`/component/delete`, { ids });
};

export const getDetail = (id) => api().get(`/component/${id}`);
export const create = (params) => api().post(`/component`, params);
export const update = (id, params) => api().put(`/component/${id}`, params);

export const getOptionsUnit = (params) => api().get('/component/unit/get-options', { params });
export const getOptionsOrigin = (params) => api().get('/component/origin/get-options', { params });
export const getOptionsManufacture = (params) => api().get('/component/manufacture/get-options', { params });
export const getListAttributes = (params) => api().get('/component/attributes', { params });
export const createAttribute = (params) => api().post(`/component/attributes`, params);

export const getOptionsStockType = params => api().get('/component/stock-type/get-options', { params });
export const getOptionsStock = params => api().get('/component/stock/get-options', { params })
export const getOptionsStore = params => api().get('/component/store/get-options', { params })
export const getOptionsOuputType = params => api().get('/component/output-type/get-options', { params });
export const getOptionsArea = params => api().get('/component/area/get-options', { params });
export const getOptionsBusiness = params => api().get('/component/business/get-options', { params });
export const getOptionsModel = params => api().get('/component/model/get-options', { params });
export const getOptionsComponentGroup = params => api().get('/component/component-group/get-options', { params });
export const getOptionsWarrantyPeriod = params => api().get('/component/warranty-period/get-options', { params });

export const getListPrintBarcode = (params = {}) => api().get('/component/barcode', { params });
export const printBarcode = (params) => api().post('/component/barcode', params)

export const exportExcel = (params) => {
    const header = {
        responseType: 'blob',
    }
    return api().get('/component/export-excel', { params, ...header });
}

export const downloadTemplate = (_data) => {
    const header = {
        responseType: 'blob',
    };
    return api().get('/component/download-excel', header);
}

export const importExcel = (file) => {
    let formData = new FormData();
    formData.append('componentimport', file);
    return api().post('/component/import-excel', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
}

export const genComponentCode = (params) => api().get('/component/gen-component-code', { params })
